<template>
  <div class="admin-products">
    <header-title title="Productos"></header-title>

    <div class="product-btn">
      <v-btn
        dense
        outlined
        v-if="isTypeDrinks"
        @click="openDrinkDialog('addDrink')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>

      <v-btn
        dense
        outlined
        v-if="isTypeFood"
        @click="openFoodDialog('addFood')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>

      <v-btn
        dense
        outlined
        v-if="isTypeDessert"
        @click="openDessertDialog('addDessert')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>
    </div>
    <ul
      class="type-toggle nav nav-fill nav-pills"
      id="pills-tab"
      role="tablist"
    >
      <li>
        <button
          id="toggle-drinks"
          :class="
            this.productTypeSelected === productTypeIds.drinks ? `active` : ''
          "
          data-toggle="pill"
          role="tab"
          :style="[
            {
              background:
                this.productTypeSelected === productTypeIds.drinks
                  ? colorsGeneralPrimary
                  : colorsGeneralSecondary
            },
            { 'border-color': colorsGeneralPrimary },
            {
              color:
                this.productTypeSelected === productTypeIds.drinks
                  ? colorsGeneralSecondary
                  : colorsGeneralPrimary
            }
          ]"
          @click="onTab(productTypeIds.drinks)"
        >
          Bebida
        </button>
      </li>
      <li>
        <button
          id="toggle-food"
          :class="
            this.productTypeSelected === productTypeIds.food ? `active` : ''
          "
          @click="onTab(productTypeIds.food)"
          data-toggle="pill"
          role="tab"
          :style="[
            {
              background:
                this.productTypeSelected === productTypeIds.food
                  ? colorsGeneralPrimary
                  : colorsGeneralSecondary
            },
            { 'border-color': colorsGeneralPrimary },
            {
              color:
                this.productTypeSelected === productTypeIds.food
                  ? colorsGeneralSecondary
                  : colorsGeneralPrimary
            }
          ]"
        >
          Comida
        </button>
      </li>
      <li>
        <button
          id="toggle-dessert"
          :class="
            this.productTypeSelected === productTypeIds.dessert ? `active` : ''
          "
          @click="onTab(productTypeIds.dessert)"
          data-toggle="pill"
          role="tab"
          :style="[
            {
              background:
                this.productTypeSelected === productTypeIds.dessert
                  ? colorsGeneralPrimary
                  : colorsGeneralSecondary
            },
            { 'border-color': colorsGeneralPrimary },
            {
              color:
                this.productTypeSelected === productTypeIds.dessert
                  ? colorsGeneralSecondary
                  : colorsGeneralPrimary
            }
          ]"
        >
          Postres
        </button>
      </li>
    </ul>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            label="Buscar producto"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="categorySelected"
            :items="categories"
            item-text="name"
            item-value="id"
            label="Filtrar por categoría"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="stockSelected"
            :items="stockList"
            item-text="name"
            item-value="value"
            label="Filtrar por stock"
          ></v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <button
            class="admin-reset-filters"
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </button>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="sortProducts(products)"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.stock`]="{ item }">
            <span
              >{{ item.stock ? "Si" : "No" }}
              <v-icon small @click="openStockDialog(item)" color="#000000"
                >mdi-pencil</v-icon
              >
            </span>
          </template>
          <template v-slot:[`item.category_id`]="{ item }">
            <v-btn
              rounded
              dark
              :x-small="true"
              class="subcategory-info"
              :style="{ 'background-color': categoryTagBackgroundTheme }"
            >
              {{ getCategory(item.category_id) }}
            </v-btn>
          </template>
          <template v-slot:[`item.sub_category_id`]="{ item }">
            <v-btn
              v-if="hasSubCategory(item.sub_category_id)"
              rounded
              dark
              :x-small="true"
              class="subcategory-info"
              :style="{ 'background-color': subCategoryTagBackgroundTheme }"
            >
              {{ getSubCategory(item.sub_category_id) }}
            </v-btn>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <div
              v-if="!isTypeFood && validBasePrice(item)"
              class="price-quantity-item"
            >
              <v-btn
                rounded
                dark
                :x-small="true"
                class="base-quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                {{ formatPriceDrink(item, "base") }}
              </v-btn>
            </div>
            <div
              v-if="!isTypeFood && validCupPrice(item)"
              class="price-quantity-item"
            >
              <v-btn
                rounded
                dark
                :x-small="true"
                class="quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                copa
                <br />
                {{ formatPriceDrink(item, "copa") }}
              </v-btn>
            </div>
            <div
              v-if="!isTypeFood && validCubataPrice(item)"
              class="price-quantity-item"
            >
              <v-btn
                rounded
                dark
                :x-small="true"
                class="quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                cubata
                <br />
                {{ formatPriceDrink(item, "cubata") }}
              </v-btn>
            </div>
            <div
              v-if="!isTypeFood && validBottlePrice(item)"
              class="price-quantity-item"
            >
              <v-btn
                rounded
                dark
                :x-small="true"
                class="quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                botella
                <br />
                {{ formatPriceDrink(item, "botella") }}
              </v-btn>
            </div>
            <div v-if="!isTypeFood && validShotPrice(item)">
              <v-btn
                rounded
                dark
                :x-small="true"
                class="quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                chupito
                <br />
                {{ formatPriceDrink(item, "chupito") }}
              </v-btn>
            </div>
            <div v-if="isTypeFood">
              <v-btn
                rounded
                dark
                :x-small="true"
                class="quantity-info"
                :style="{ 'background-color': priceTagBackgroundTheme }"
              >
                {{ formatPriceFood(item.price) }}
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.updated_on`]="{ item }">
            <span class="day-format">{{
              dayFormatLLAndTime2(item.updated_on)
            }}</span>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon
              v-if="isTypeDrinks"
              small
              class="mr-2"
              @click="openDrinkDialog(item.id)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="isTypeFood"
              small
              class="mr-2"
              @click="openFoodDialog(item.id)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="isTypeDessert"
              small
              class="mr-2"
              @click="openDessertDialog(item.id)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:[`item.deleteAction`]="{ item }">
            <v-icon class="mr-2" @click="deleteProductDialog(item.id)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <ProductDrinkDialog
      v-if="isTypeDrinks"
      :categorySelected="categorySelected"
      ref="productDrinkDialog"
    ></ProductDrinkDialog>

    <ProductFoodDialog
      v-if="isTypeFood"
      :categorySelected="categorySelected"
      ref="productFoodDialog"
    ></ProductFoodDialog>

    <ProductDessertDialog
      v-if="isTypeDessert"
      :categorySelected="categorySelected"
      ref="productDessertDialog"
    ></ProductDessertDialog>

    <v-row justify="center">
      <DeleteDialog
        :dialog="dialog"
        :is-type-drinks="isTypeDrinks"
        :is-type-food="isTypeFood"
        :is-type-dessert="isTypeDessert"
        @cancel="deleteCancel"
        @deleteDrinks="deleteDrinks"
        @deleteFood="deleteFood"
        @deleteDessert="deleteDessert"
      ></DeleteDialog>
      <StockDialog ref="stockdialog"></StockDialog>
    </v-row>
  </div>
</template>

<script>
import ProductDrinkDialog from "../../../components/admin/product/ProductDrinkDialog";
import ProductFoodDialog from "../../../components/admin/product/ProductFoodDialog";
import ProductDessertDialog from "../../../components/admin/product/ProductDessertDialog";
import StockDialog from "../../../components/admin/product/StockDialog.vue";
import moment from "moment";
import { orderBy } from "lodash";
import DeleteDialog from "@/components/admin/product/DeleteDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { ProductsTableHeader } from "@/utils/tableHeaderconstants";
import { subCategoriesCollection } from "@/collections/subCategories";
import { deleteStripeProduct } from "@/collections/stripeProducts";
import {
  deleteStripeSku,
  getStripeSkuByProduct
} from "@/collections/stripeSkus";
import {
  deleteDessert,
  dessertCollection,
  updateDessert
} from "@/collections/dessert";
import { deleteFood, foodCollection, updateFood } from "@/collections/food";
import {
  deleteDrink,
  drinksCollection,
  updateDrink
} from "@/collections/drinks";
import { menusCollection, updateMenu } from "@/collections/menus";
import { menuGroupCollection, updateMenuGroup } from "@/collections/menuGroup";
import { categoriesCollection } from "@/collections/categories";
let fromRoute = undefined;
export default {
  name: "Products",
  components: {
    DeleteDialog,
    ProductDrinkDialog,
    ProductFoodDialog,
    ProductDessertDialog,
    HeaderTitle,
    StockDialog
  },
  data() {
    return {
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: [],
      categoriesCollection: [],
      subCategoriesCollection: [],
      productTypeSelected: "",
      lastSubcategoryId: "",
      search: "",
      categorySelected: "",
      stockSelected: null,
      stockList: [
        {
          name: "Todos",
          value: null
        },
        {
          name: "Sin stock",
          value: 0
        },
        {
          name: "Con stock",
          value: 1
        }
      ],
      sortAlphabetically: false,
      sortNumericaly: false,
      dialog: false,
      selectedProductId: null,
      menusCollection: [],
      menuGroupCollection: [],
      headers: [...ProductsTableHeader]
    };
  },
  firestore() {
    return {
      drinksCollection: drinksCollection.orderBy("name"),
      foodCollection: foodCollection.orderBy("name"),
      dessertCollection: dessertCollection.orderBy("name"),
      categoriesCollection: categoriesCollection,
      subCategoriesCollection: subCategoriesCollection,
      menusCollection: menusCollection,
      menuGroupCollection: menuGroupCollection
    };
  },
  computed: {
    isTypeFood() {
      return this.productTypeSelected === this.$store.state.productTypeIds.food;
    },
    isTypeDrinks() {
      return (
        this.productTypeSelected === this.$store.state.productTypeIds.drinks
      );
    },
    isTypeDessert() {
      return (
        this.productTypeSelected === this.$store.state.productTypeIds.dessert
      );
    },
    categories() {
      // When a product type is selected it will automatically show the categories
      return this.categoriesCollection.filter(
        category => this.productTypeSelected === category.product_type_id
      );
    },
    // eslint-disable-next-line vue/return-in-computed-property
    products() {
      if (this.categories.length > 0 && this.isTypeDrinks) {
        // Apply filters
        return this.drinksFiltered();
      }

      if (this.categories.length > 0 && this.isTypeFood) {
        // Apply filters
        return this.foodFiltered();
      }

      if (this.categories.length > 0 && this.isTypeDessert) {
        // Apply filters
        return this.dessertFiltered();
      }
    }
  },
  mounted() {
    if (
      fromRoute &&
      (fromRoute.name === "EditProductFood" ||
        fromRoute.name === "AddProductFood")
    ) {
      this.onTab(this.productTypeIds.food);
    } else {
      this.onTab(this.productTypeIds.drinks);
    }
    setTimeout(() => {}, 2000);
  },
  methods: {
    onTab(productTypeId) {
      this.selectProductType(productTypeId);
      this.resetFilters();
    },
    sortProducts(products) {
      if (!products) {
        return [];
      }

      products = orderBy(
        products,
        o => {
          return moment(
            o.updated_on ||
              moment()
                .subtract(1, "M")
                .format()
          );
        },
        ["desc"]
      );

      if (this.sortAlphabetically) {
        products = products.sort(this.dynamicsort("name", "asc"));
      }

      if (this.sortNumericaly) {
        products = products.sort(this.dynamicsort("sort", "asc"));
      }
      return products;
    },
    sortAlphabeticallyHandel(products) {
      this.sortAlphabetically = !this.sortAlphabetically;
      this.sortProducts(products);
    },
    sortNumericalyHandel(products) {
      this.sortNumericaly = !this.sortNumericaly;
      this.sortProducts(products);
    },
    drinksFiltered() {
      let search =
        this.search === ""
          ? this.drinksCollection
          : this.drinksCollection.filter(drink => {
              return drink.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
            });

      //stock filter
      search =
        this.stockSelected !== null
          ? search.filter(drink => {
              if (this.stockSelected === 0) {
                return drink.stock === 0;
              }

              if (this.stockSelected === 1) {
                return drink.stock > 0;
              }
            })
          : search;

      // category filter
      search =
        this.categorySelected !== ""
          ? search.filter(drink => this.categorySelected === drink.category_id)
          : search;

      return search;
    },
    foodFiltered() {
      let search =
        this.search === ""
          ? this.foodCollection
          : this.foodCollection.filter(food => {
              return food.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
            });

      //stock filter
      search =
        this.stockSelected !== null
          ? search.filter(food => {
              if (this.stockSelected === 0) {
                return food.stock === 0;
              }

              if (this.stockSelected === 1) {
                return food.stock > 0;
              }
            })
          : search;

      // category filter
      search =
        this.categorySelected !== ""
          ? search.filter(food => this.categorySelected === food.category_id)
          : search;

      return search;
    },
    dessertFiltered() {
      let search =
        this.search === ""
          ? this.dessertCollection
          : this.dessertCollection.filter(dessert => {
              return dessert.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
            });

      //stock filter
      search =
        this.stockSelected !== null
          ? search.filter(dessert => {
              if (this.stockSelected === 0) {
                return dessert.stock === 0;
              }

              if (this.stockSelected === 1) {
                return dessert.stock > 0;
              }
            })
          : search;

      // category filter
      search =
        this.categorySelected !== ""
          ? search.filter(
              dessert => this.categorySelected === dessert.category_id
            )
          : search;

      return search;
    },
    resetFilters() {
      this.search = "";
      this.categorySelected = "";
    },
    selectProductType(id) {
      this.productTypeSelected = id;
    },
    hasSubCategory(id) {
      return this.getSubCategoryName(this.subCategoriesCollection, id) !== "";
    },
    getCategory(id) {
      if (this.categories !== undefined) {
        return this.getCategoryName(this.categories, id);
      }
    },
    getSubCategory(id) {
      if (this.subCategoriesCollection !== undefined) {
        return this.getSubCategoryName(this.subCategoriesCollection, id);
      }
    },
    formatPriceDrink(product, size) {
      const number = this.getPriceBySize(product, size);
      return this.formatPrice(number);
    },
    formatPriceFood(number) {
      return this.formatPrice(number);
    },
    validBasePrice(product) {
      return (
        product.price !== undefined &&
        product.price !== "" &&
        product.price !== null
      );
    },
    validCupPrice(product) {
      return (
        product.price_cup !== undefined &&
        product.price_cup !== "" &&
        product.price_cup !== null
      );
    },
    validBottlePrice(product) {
      return (
        product.price_bottle !== undefined &&
        product.price_bottle !== "" &&
        product.price_bottle !== null
      );
    },
    validShotPrice(product) {
      return (
        product.price_shot !== undefined &&
        product.price_shot !== "" &&
        product.price_shot !== null
      );
    },
    validCubataPrice(product) {
      return (
        product.price_cubata !== undefined &&
        product.price_cubata !== "" &&
        product.price_cubata !== null
      );
    },
    openDrinkDialog(itemId) {
      this.itemId = itemId;
      this.$refs.productDrinkDialog.open(itemId);
    },
    openFoodDialog(itemId) {
      this.itemId = itemId;
      this.$refs.productFoodDialog.open(itemId);
    },
    openDessertDialog(itemId) {
      this.itemId = itemId;
      this.$refs.productDessertDialog.open(itemId);
    },
    deleteProductDialog(id) {
      this.selectedProductId = id;
      this.dialog = true;
    },
    deleteCancel() {
      this.dialog = false;
    },
    async deleteDrinks() {
      try {
        this.menusCollection.forEach(async element => {
          try {
            let index = element.drink_ids.findIndex(
              e => e === this.selectedProductId
            );
            let drink_ids = element.drink_ids;
            drink_ids.splice(index, 1);
            await updateMenu(element.id, { drink_ids: drink_ids });
          } catch (error) {
            this.setlogError(
              "update_menu",
              "Obtained error message in deleteDrinks()",
              error.stack,
              this.$options.name
            );
          }
        });

        // delete from menu group collection
        this.menuGroupCollection.forEach(async element => {
          try {
            let foundIndex = element.drink_ids.findIndex(
              e => e.id === this.selectedProductId
            );
            let menugroup_drink_ids = element.drink_ids;
            if (foundIndex >= 0) {
              menugroup_drink_ids.splice(foundIndex, 1);
            }
            await updateMenuGroup(element.id, {
              drink_ids: menugroup_drink_ids
            });
          } catch (error) {
            this.setlogError(
              "update_menu_group",
              "Obtained error message in deleteDrinks()",
              error.stack,
              this.$options.name
            );
          }
        });
        //Delete product from Stripe
        await deleteStripeProduct(this.selectedProductId);
        let product = await getStripeSkuByProduct(this.selectedProductId);
        if (product) {
          await deleteStripeSku(product.sku);
        }

        // Delete from drink collection
        await deleteDrink(this.selectedProductId);

        this.dialog = false;

        // update sort in  drinks
        if (this.categorySelected !== "") {
          let orderByDrinksCollection = this.sortProducts(
            this.drinksCollection
          );
          let filterProducts = orderByDrinksCollection.filter(
            drink => this.categorySelected === drink.category_id
          );

          filterProducts.forEach(async (item, index) => {
            try {
              item.sort = index + 1;
              await updateDrink(item.id, {
                sort: item.sort,
                updated_on: moment().format()
              });
            } catch (error) {
              this.setlogError(
                "update_drink",
                "Obtained error message in deleteDrinks()",
                error.stack,
                this.$options.name
              );
            }
          });
        }
      } catch (error) {
        this.setlogError(
          "delete_stripe_product/drinks/stripe_sku/get_stripe_sku_by_product",
          "Obtained error message in deleteDrinks()",
          error.stack,
          this.$options.name
        );
      }
    },
    async deleteFood() {
      try {
        this.menusCollection.forEach(async element => {
          try {
            let index = element.food_ids.findIndex(
              e => e === this.selectedProductId
            );
            let food_ids = element.food_ids;
            food_ids.splice(index, 1);
            await updateMenu(element.id, { food_ids: food_ids });
          } catch (error) {
            this.setlogError(
              "update_menu",
              "Obtained error message in deleteFood()",
              error.stack,
              this.$options.name
            );
          }
        });

        this.menuGroupCollection.forEach(async element => {
          try {
            // delete food product from menu group starters
            let index = element.starter_ids.findIndex(
              e => e.id === this.selectedProductId
            );
            let starter_ids = element.starter_ids;
            if (index >= 0) {
              starter_ids.splice(index, 1);
            }
            await updateMenuGroup(element.id, { starter_ids: starter_ids });

            // delete food product from menu group' maincourse_ids
            let foundIndex = element.maincourse_ids.findIndex(
              e => e.id === this.selectedProductId
            );
            let maincourse_ids = element.maincourse_ids;
            if (foundIndex >= 0) {
              maincourse_ids.splice(foundIndex, 1);
            }
            await updateMenuGroup(element.id, {
              maincourse_ids: maincourse_ids
            });
          } catch (error) {
            this.setlogError(
              "update_menu_group",
              "Obtained error message in deleteFood()",
              error.stack,
              this.$options.name
            );
          }
        });

        //Delete product from Stripe
        await deleteStripeProduct(this.selectedProductId);
        let product = await getStripeSkuByProduct(this.selectedProductId);
        if (product) {
          await deleteStripeSku(product.sku);
        }

        // Delete from food collection
        await deleteFood(this.selectedProductId);

        // update sort food
        if (this.categorySelected !== "") {
          let orderByFoodCollection = this.sortProducts(this.foodCollection);
          let filterProducts = orderByFoodCollection.filter(
            food => this.categorySelected === food.category_id
          );

          filterProducts.forEach(async (item, index) => {
            try {
              item.sort = index + 1;
              await updateFood(item.id, {
                sort: item.sort,
                updated_on: moment().format()
              });
            } catch (error) {
              this.setlogError(
                "update_food",
                "Obtained error message in deleteFood()",
                error.stack,
                this.$options.name
              );
            }
          });
        }

        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "delete_stripe_product/food/stripe_sku/get_stripe_sku_by_product",
          "Obtained error message in deleteFood()",
          error.stack,
          this.$options.name
        );
      }
    },
    async deleteDessert() {
      try {
        this.menusCollection.forEach(async element => {
          try {
            if (element.dessert_ids) {
              let index = element.dessert_ids.findIndex(
                e => e === this.selectedProductId
              );
              let dessert_ids = element.dessert_ids;
              dessert_ids.splice(index, 1);
              await updateMenu(element.id, { dessert_ids: dessert_ids });
            }
          } catch (error) {
            this.setlogError(
              "update_menu",
              "Obtained error message in deleteDessert()",
              error.stack,
              this.$options.name
            );
          }
        });

        // delete from menu group's dessert ids collection
        this.menuGroupCollection.forEach(async element => {
          try {
            let index = element.dessert_ids.findIndex(
              e => e.id === this.selectedProductId
            );
            let menugroup_dessert_ids = element.dessert_ids;
            if (index >= 0) {
              menugroup_dessert_ids.splice(index, 1);
            }
            await updateMenuGroup(element.id, {
              dessert_ids: menugroup_dessert_ids
            });
          } catch (error) {
            this.setlogError(
              "update_menu_group",
              "Obtained error message in deleteDessert()",
              error.stack,
              this.$options.name
            );
          }
        });

        //Delete product from Stripe
        await deleteStripeProduct(this.selectedProductId);
        let product = await getStripeSkuByProduct(this.selectedProductId);
        if (product) {
          await deleteStripeSku(product.sku);
        }

        // Delete from dessert collection
        await deleteDessert(this.selectedProductId);

        // update sort dessert
        if (this.categorySelected !== "") {
          let orderByDessertCollection = this.sortProducts(
            this.dessertCollection
          );
          let filterProducts = orderByDessertCollection.filter(
            dessert => this.categorySelected === dessert.category_id
          );

          filterProducts.forEach(async (item, index) => {
            try {
              item.sort = index + 1;
              await updateDessert(item.id, {
                sort: item.sort,
                updated_on: moment().format()
              });
            } catch (error) {
              this.setlogError(
                "update_dessert",
                "Obtained error message in deleteDessert()",
                error.stack,
                this.$options.name
              );
            }
          });
        }

        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "delete_stripe_product/dessert/stripe_sku/get_stripe_sku_by_product",
          "Obtained error message in deleteDessert()",
          error.stack,
          this.$options.name
        );
      }
    },
    openStockDialog(item) {
      this.$refs.stockdialog.open(item);
    }
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>

<style>
.v-input__slot {
  justify-content: center;
}
</style>
